<section class="AmountCard">
  <div class="AmountCard__Container">
    <div class="AmountCard__AmountDetails">
      <h2 class="AmountCard__Amount">{{ amount }}</h2>
      <p class="AmountCard__AmountDetail">
        {{ amountTypeDetail }} {{ config.amountType.label }}
      </p>
      <p class="AmountCard__Description">
        {{ config.customerServiceDescription }}
      </p>
      @if (config.documentDescription) {
        <p class="AmountCard__Description">
          {{ documentDescription }}
        </p>
      }
    </div>

    <div class="AmountCard__LinkDetails">
      @for (data of config.list; track data) {
        <div class="AmountCard__LinkList">
          @if (data) {
            <a
              [href]="data.href"
              [attr.target]="data.target ? data.target : '_blank'"
              class="u-flex"
              (click)="linkClicked(data)"
            >
              <icon
                class="AmountCard__Icon"
                [name]="data.icon"
                [config]="{
                  type: 'link',
                }"
              >
              </icon>
              <p class="t-data">
                {{ data.label }}
              </p>
            </a>
          }
        </div>
      }
    </div>
  </div>
  @if (enablePayButton) {
    <footer class="AmountCard__Footer">
      <zip-button
        [config]="config.paymentButton"
        (zipButtonClicked)="makePaymentFromAccountClicked()"
      >
      </zip-button>
    </footer>
  }
</section>
